export function pdfAmountFormat(number, currency) {
    const numericValue = parseFloat(number);

    // Check if numericValue is a valid number
    if (!isNaN(numericValue)) {
        // Convert number to string and split it into integer and decimal parts
        const [integerPart, decimalPart] = numericValue.toFixed(2).split(".");

        // Add dots every three digits in the integer part for thousands separation
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        // Combine integer and decimal parts with a comma as the decimal separator
        return `${formattedInteger},${decimalPart}`;
    }

    // Return "0,00" if the input is not a valid number
    return "0,00";

}
